export default __webpack_public_path__ + "static/media/fortmatic.f7516629.svg";